exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trial-balance-page[data-v-49f18d00]{background:#f5f7fb}.page-toolbar[data-v-49f18d00]{border-radius:6px 6px 0 0}.summary-card[data-v-49f18d00]{min-height:116px}.report-card[data-v-49f18d00]{border-radius:10px}.report-row[data-v-49f18d00]:hover{background:#f8fbff}.summary-total-row[data-v-49f18d00]{background:#e3f2fd!important}.summary-total-row td[data-v-49f18d00]{font-weight:700}@media (max-width:960px){.trial-balance-page[data-v-49f18d00]{overflow-x:hidden}}", ""]);

// exports
